import _apply_rules from './_apply_rules';
import indexOf from '../indexOf';
import pluralize from '../pluralize';
import singularize from '../singularize';
import inflect from '../inflect';
import camelize from '../camelize';
import underscore from '../underscore';
import humanize from '../humanize';
import capitalize from '../capitalize';
import dasherize from '../dasherize';
import titleize from '../titleize';
import demodulize from '../demodulize';
import tableize from '../tableize';
import kebabize from '../kebabize';
import classify from '../classify';
import foreign_key from '../foreign_key';
import ordinalize from '../ordinalize';

export const inflector = {

	pluralize,

	singularize,

	inflect,

	camelize,

	underscore,

	humanize,

	capitalize,

	dasherize,

	titleize,

	demodulize,

	tableize,

	kebabize,

	classify,

	foreign_key,

	ordinalize,

};

export default inflector
